import React from 'react';
import { CheckIcon } from 'lucide-react';
import { promptQualities, volumes } from '../data/volumes';
export function PromptLibrary() {
  return <section aria-labelledby="library-title" className="bg-white" data-id="element-291" data-mp="9a6dhp80xi33">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "18px",
      paddingBottom: "25px"
    }} data-id="element-292" data-mp="e7ya2wjm5sdm">
        <div className="grid items-center gap-6 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-293" data-mp="j9njk7r6txzl">
          <p className="font-display text-[120px] font-black leading-none tracking-tighter text-gold sm:text-[180px]" aria-hidden="true" data-id="element-294" data-mp="o6dygrr9anjf">
            100
          </p>
          <div data-id="element-295" data-mp="wyz3z65vmxqb">
            <h2 id="library-title" className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-296" data-mp="wz7jz6xaqj5q">
              <span className="sr-only" data-id="element-297" data-mp="11x929pmweeg5">100 </span>Specialized AI prompts.
            </h2>
            <p className="mt-3 text-lg text-muted" data-id="element-298" data-mp="16yq2dixk5wvo">6 strategic workflows. One complete real estate AI system.</p>
          </div>
        </div>

        <ol className="mt-12 grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-3 lg:grid-cols-6" aria-label="Prompts per volume" data-id="element-299" data-mp="1budotqknobxh">
          {volumes.map(v => <li key={v.n} className="border-t-2 border-navy pt-4" data-id="element-300" data-mp="eiu4xjng5q14">
              <p className="text-xs font-bold text-gold-ink" data-id="element-301" data-mp="9k0uy17dch5p">{String(v.n).padStart(2, '0')}</p>
              <p className="mt-1 font-display text-base font-extrabold text-ink" data-id="element-302" data-mp="5if8pp8y2qiu">{v.label}</p>
              <p className="mt-0.5 text-sm text-muted" data-id="element-303" data-mp="5ks00t0led8k">{v.count} prompts</p>
            </li>)}
        </ol>

        <div className="mt-16 grid gap-10 border-t border-line pt-12 lg:grid-cols-[1fr_1.4fr] lg:gap-16" style={{
        paddingTop: "10px"
      }} data-id="element-304" data-mp="x9lccfnvj6cv">
          <div data-id="element-305" data-mp="shtmy8ggf6ob">
            <p className="font-display text-2xl font-black leading-snug text-ink sm:text-3xl" data-id="element-306" data-mp="shbrvf5j2yhz">
              100 AI prompts.
              <br data-id="element-307" data-mp="ofgq69joqj3o" />6 real estate workflows.
              <br data-id="element-308" data-mp="1kzfrj3vo170a" />
              <span className="text-gold-ink" data-id="element-309" data-mp="1kzz4s7adf77z">One complete system.</span>
            </p>
          </div>
          <div data-id="element-310" data-mp="1g6wce2hby3td">
            <p className="text-sm font-semibold text-muted" data-id="element-311" data-mp="1g6csig84d5cp">Every prompt is designed to be:</p>
            <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-312" data-mp="3ah327uiz8saw">
              {promptQualities.map(q => <li key={q} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-313" data-mp="3feuwuwb0asis">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-314" data-mp="30pqe9e0auma5" />
                  {q}
                </li>)}
            </ul>
            <p className="mt-8 text-base text-muted" data-id="element-315" data-mp="2rpa8fxw33324">
              You don’t have to figure out the prompt from scratch.{' '}
              <span className="font-semibold text-ink" data-id="element-316" data-mp="2wpo8otrg18pl">You start with the framework.</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}